import React, { useContext, useEffect } from 'react';

import { ItemsList } from '@/components/shared/ItemsList';
import { useAuth } from '@/providers/AuthProvider';

import { CopilotContext } from '../CopilotPage';

const CopilotLoggingIn: React.FC = () => {
	const { token, pcoSongs } = useContext(CopilotContext);
	const { authenticate } = useAuth();

	useEffect(() => {
		if (token) {
			authenticate(token, true);
		}
	}, [token, authenticate]);
	return (
		<>
			<h2>Progress</h2>
			<ItemsList
				items={[
					{
						label: 'Account verified',
						checked: true,
					},
					{
						label: `Prepared ${pcoSongs.length} songs`,
						checked: true,
					},
					{
						label: 'Songs imported',
						checked: true,
					},
					{
						label: 'Logging you in...',
						checked: false,
					},
				]}
			/>
		</>
	);
};

export default CopilotLoggingIn;
